import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { validaSoloNumero, formatMoneda, validaMonto, formatoMonto } from '../../util/varios';
import axios from 'axios';
import { Dimmer } from '../spinner';
import CatalogoProductosOc from '../../catalogos/catalogoProductosOC';

export const ActualizarProductoCompra = (props) => {
  /* variables de estados */
  let token = localStorage.getItem('jwtToken');
  let op = require('../../modulos/datos');

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [catalogoProducto, setCatalogoProducto] = useState(false);
  const [iva, setIva] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  // Referencias para los nuevos campos
  const txtCodigo = useRef();
  const txtDescripcion = useRef();
  const txtUnidadMedida = useRef();
  const txtPrecioUnitario = useRef();
  const txtCantidad = useRef();
  const txtDescuento = useRef();
  const txtPorcentajeIva = useRef();
  const txtMontoIva = useRef();
  const txtTotalSinIva = useRef();
  const txtGarantia = useRef();
  const [total, setTotal] = useState()
  const [values, setValues] = useState({
    codigo: '',
    descripcion: '',
    unidadMedida: '',
    precioUnitario: '0,00',
    cantidad: '0,00',
    descuento: '0,00',
    porcentajeIva: '0,00',
    montoiva: '0,00',
    totalsiniva: '0,00',
    garantia: '0,00'
  });

  const seleccionarIva = (id) => {

    let campos = "*"
    let nomtab = "iva";
    let nomid = "idiva";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        'Content-Type': 'application/json'

      },
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idiva > 0) {
          setIva(response.data.porcentaje);
        } else {
          setIva(0.00);
        }

      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  useEffect(() => {
    seleccionarIva(1);
  }, []);

  const handleIdProducto = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtDescripcion.current.value = "";
    txtUnidadMedida.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro(event.target.value, event.which);
      }


    }
    /* if (event.which === 13) {
         txtPrecioUnitario.current.focus();
    } else {
         if (event.target.value !== "") {
             seleccionarRegistro(event.target.value, event.which);
         }
     } */
  };

  const onChange = (event) => {
    if (event.target.name === 'descripcion') {
      event.target.value = event.target.value.toUpperCase();
    }
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
      event.target.value = '0,00'
    }

    if (event.which === 13 || typeof (event.which) === 'undefined') {
      event.target.value = (formatoMonto(event.target.value));
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === '0' && char2 !== ',') {
        event.target.value = event.target.value.substring(1, event.target.value.length);
      }

      // Recalcular valores cuando cambie algún campo numérico
      recalcularValores(event.target.name, event.target.value);
      if (event.which === 13) {
        if (event.target.name === 'precioUnitario') {
          txtCantidad.current.focus();
        } else if (event.target.name === 'cantidad') {
          txtDescuento.current.focus();
        } else if (event.target.name === 'descuento') {
          txtPorcentajeIva.current.focus();
        } else if (event.target.name === 'porcentajeIva') {
          txtGarantia.current.focus();
        } else if (event.target.name === 'garantia') {
          btnAcepta.current.focus();
        }
      }

    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const recalcularValores = (campo, valor) => {
    // Convertir valores a números
    const precioUnitario = parseFloat(txtPrecioUnitario.current.value.replace(/\./g, '').replace(',', '.')) || 0;
    const cantidad = parseFloat(txtCantidad.current.value.replace(/\./g, '').replace(',', '.')) || 0;
    const descuento = parseFloat(txtDescuento.current.value.replace(/\./g, '').replace(',', '.')) || 0;
    const porcentajeIva = parseFloat(txtPorcentajeIva.current.value.replace(/\./g, '').replace(',', '.')) || 0;

    // Calcular subtotal
    const subtotal = precioUnitario * cantidad;

    // Calcular total sin IVA (subtotal - descuento)
    const totalSinIva = Math.max(0, subtotal - descuento);

    // Calcular monto IVA
    const montoIva = totalSinIva * (porcentajeIva / 100);
    const totalConIva = parseFloat(totalSinIva) + parseFloat(montoIva)
    setTotal(formatMoneda(totalConIva.toString().replace(',', '').replace('.', ','), ',', '.', 2))
    // Actualizar valores
    setValues(prev => ({
      ...prev,
      totalsiniva: formatMoneda(totalSinIva.toString().replace(',', '').replace('.', ','), ',', '.', 2),
      montoiva: formatMoneda(montoIva.toString().replace(',', '').replace('.', ','), ',', '.', 2)
    }));
    txtTotalSinIva.current.value = formatMoneda(totalSinIva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
    txtMontoIva.current.value = formatMoneda(montoIva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
  };

  const Actualizar = (operacion) => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/createProducto/${operacion}`;
    setActivate(true);

    const body = {
      codigo: txtCodigo.current.value,
      descripcion: txtDescripcion.current.value.trim(),
      unidadMedida: txtUnidadMedida.current.value,
      precioUnitario: txtPrecioUnitario.current.value.trim().replace(/\./g, '').replace(',', '.'),
      cantidad: txtCantidad.current.value.trim().replace(/\./g, '').replace(',', '.'),
      descuento: txtDescuento.current.value.trim().replace(/\./g, '').replace(',', '.'),
      porcentajeIva: txtPorcentajeIva.current.value.trim().replace(/\./g, '').replace(',', '.'),
      montoiva: txtMontoIva.current.value.trim().replace(/\./g, '').replace(',', '.'),
      totalsiniva: txtTotalSinIva.current.value.trim().replace(/\./g, '').replace(',', '.'),
      garantia: txtGarantia.current.value.trim().replace(/\./g, '').replace(',', '.')
    };

    console.log(body);

    axios.post(endpoint, body, {
      headers: {
        "x-access-token": `${token}`,
        'Content-Type': 'application/json'
      },
    }).then(function (response) {
      if (response.status === 200) {
        props.onHideRenderizar();

        if (props.operacion === 1) {
          setTitulo("Notificación");
          setMsg("Registro Creado Correctamente.");
        } else if (props.operacion === 2) {
          setTitulo("Notificación");
          setMsg("Registro Modificado Correctamente.");
        } else if (props.operacion === 3) {
          setTitulo("Notificación");
          setMsg("Registro Eliminado Correctamente.");
        }
        setMostrar(true);
      }
      setActivate(false);
    }).catch(function (error) {
      setTitulo("ERROR");
      setMsg(error.response?.data?.message || "Error en la operación");
      setMostrar(true);
      setActivate(false);
    });
  };

  const cerrarModal = (e) => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    /* e.preventDefault();
    setMostrar(false);
    if (msg.includes('Correctamente')) {
        blanquear();
        props.onHideCancela();
    } */
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;

    if (txtCodigo.current.value.trim() === '') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código no puede estar vacío.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtDescripcion.current.value.trim() === '') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La descripción no debe estar vacía.",
        icono: "informacion",
      });
      sigue = false;
      txtDescripcion.current.focus();
    } else if (txtPrecioUnitario.current.value.trim() === '') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El precio unitario no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtPrecioUnitario.current.focus();
    } else if (txtPrecioUnitario.current.value.trim() === '0,00') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El precio unitario no debe ser cero.",
        icono: "informacion",
      });
      sigue = false;
      txtPrecioUnitario.current.focus();
    } else if (txtCantidad.current.value.trim() === '') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La cantidad no debe estar vacia.",
        icono: "informacion",
      });
      sigue = false;
      txtCantidad.current.focus();
    } else if (txtCantidad.current.value.trim() === '0,00') {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La cantidad no debe ser cero.",
        icono: "informacion",
      });
      sigue = false;
      txtCantidad.current.focus();
    }

    if (sigue) {
      setTotal()
      //Actualizar(props.operacion);
      props.onHideAcepta({
        idproducto: txtCodigo.current.value,
        descripcion: txtDescripcion.current.value.trim(),
        unidadMedida: txtUnidadMedida.current.value,
        precioUnitario: txtPrecioUnitario.current.value.trim(),
        cantidad: txtCantidad.current.value.trim(),
        descuento: txtDescuento.current.value.trim() === "" ? "0,00" : txtDescuento.current.value.trim(),
        porcentajeIva: txtPorcentajeIva.current.value.trim(),
        montoiva: txtMontoIva.current.value.trim(),
        totalsiniva: txtTotalSinIva.current.value.trim(),
        garantia: txtGarantia.current.value.trim()
      });
    } else {
      setMostrar(true);
    }
  };

  const blanquear = () => {
    setActivate(false);
    setValues({
      codigo: '',
      descripcion: '',
      unidadMedida: '',
      precioUnitario: '0,00',
      cantidad: '0,00',
      descuento: '0,00',
      porcentajeIva: '0,00',
      montoiva: '0,00',
      totalsiniva: '0,00',
      garantia: '0,00'
    });
    setMsg('');
    setDeshabilitado(false)
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const onCatalogoProducto = (values) => {
    setCatalogoProducto(false);
    console.log("aqui cierra catalogo ", values);
    if (values) {
      txtCodigo.current.value = values;
      seleccionarRegistro(values, 13);
    }
    blanquear();
  };

  const seleccionarRegistro = (id, tecla) => {
    /* let campos = "*";
    let nomtab = "producto";
    let nomid = "idproducto";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`; */

    let campos = "producto.idproducto, producto.descripcion, producto.servicio, producto.exento, unidadmedida.descripcion as decripmedida";
    let nomtab = "producto";
    let nomid = "idproducto";
    let nomtab2 = "unidadmedida";
    let nomid3 = "idunidadmedida";

    let endpoint = `${op.conexion}/api/consulta/modeli10?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${parseInt(id)}&nomtab2=${nomtab2}&nomid3=${nomid3}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {

            if (response.data.servicio === props.servicio) {
              //txtCodigo.current.value = response.data.idproducto;
              for (let i = 0; i < props.productos.length; i++) {
                if (props.productos[i].idproducto === response.data.idproducto) {
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "El Producto ya fue agregado a la lista.",
                    icono: "informacion",
                  });
                  txtCodigo.current.value = "";
                  txtCodigo.current.focus();
                  setActivate(false);
                  return;
                }

              }
              if (props.exento === false && response.data.exento === false) {
                setDeshabilitado(false);
                txtPorcentajeIva.current.value = formatMoneda(iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              } else {
                setDeshabilitado(true);
                txtPorcentajeIva.current.value = "0,00";
              }
              txtDescripcion.current.value = response.data.descripcion.trim();
              txtUnidadMedida.current.value = response.data.decripmedida.trim();

              if (tecla === 13) {
                txtPrecioUnitario.current.focus();
              }
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Producto no corresponde al tipo de compra seleccionado.",
                icono: "informacion",
              });
              txtCodigo.current.value = "";
              txtCodigo.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Producto no existe.",
              icono: "informacion",
            });
            txtCodigo.current.value = "";
            txtCodigo.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleGarantia = (event) => {
    if (event.which === 13) {
      btnAcepta.current.focus();
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      style={{
        background: '#000000b5'
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setTotal()
        btnAcepta.current.focus();
        setOperacion(props.operacion);

        if (props.operacion !== 1 && props.productoSeleccionado) {
          const p = props.productoSeleccionado;
          const cantidad = parseFloat(p.cantidad) || 0;
          const precioUnitario = parseFloat(p.punitario) || 0;
          const descuento = parseFloat(p.descuento) || 0;
          const porceIva = parseFloat(p.iva) || 0;
          const subTotalSinDescuento = precioUnitario * cantidad;
          const baseImponible = subTotalSinDescuento - descuento;
          const montoIva = (baseImponible * porceIva) / 100;
          const totalFactura = baseImponible + montoIva;
          txtCodigo.current.value = p.idproducto;
          txtDescripcion.current.value = p.descripcion;
          txtUnidadMedida.current.value = '';
          const format = (valor) => formatMoneda(valor.toString().replace('.', ','), ',', '.', 2);
          txtPrecioUnitario.current.value = format(precioUnitario);
          txtCantidad.current.value = format(cantidad);
          txtDescuento.current.value = format(descuento);
          txtPorcentajeIva.current.value = format(porceIva);
          txtMontoIva.current.value = format(montoIva);
          txtTotalSinIva.current.value = format(subTotalSinDescuento);
          txtGarantia.current.value = p.garantia;
          const totalFormateado = format(totalFactura);
          setTotal(totalFormateado);

        }
      }}
    >
      <Modal.Header className='azulGradiant'>
        <Modal.Title style={{ color: "#fff" }}>
          {operacion === 1 ? 'Agregar Producto' :
            operacion === 2 ? 'Modificar Producto' :
              operacion === 3 ? 'Eliminar Producto' :
                'Consultar Producto'}
        </Modal.Title>
        <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          }}
        />

        <MensajeSiNo mensaje={MensajeSiNo}
          onHideSi={handleCloseSi} onHideNo={handleCloseNo} />

        <CatalogoProductosOc
          show={catalogoProducto}
          servicio={props.servicio}
          onHideCancelar={() => setCatalogoProducto(false)}
          onHideAceptaCatalogo={onCatalogoProducto}
        />

        <Dimmer active={activate} inverted></Dimmer>

        <div className='rounded mx-auto py-0  col-md-12 row px-0 mx-auto'>

          <div className="input-group input-group-sm col-md-12 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Código</span>
            </div>
            <input
              type="text"
              ref={txtCodigo}
              name="codigo"
              disabled={operacion !== 1 ? true : false}
              className="form-control text-uppercase col-md-1"
              autoComplete='off'
              //value={values.codigo}
              //onChange={handleIdProducto}
              onKeyUp={handleIdProducto}
              onBlur={handleIdProducto}
            />
            <button className="btn btn-success btn-sm" onClick={() => setCatalogoProducto(true)} ><i class="fas fa-search"></i></button>


            <input
              type="text"
              ref={txtDescripcion}
              name="descripcion"
              disabled={true}
              className="form-control text-uppercase"
              //value={values.descripcion}
              onChange={onChange}
            />
          </div>
          <div className="input-group input-group-sm col-md-3 mb-1 px-0">

            <div className="input-group-prepend">
              <span className="input-group-text">Unidad de Medida</span>
            </div>
            <input
              type="text"
              ref={txtUnidadMedida}
              name="unidadMedida"

              disabled={true}
              className="form-control text-uppercase"
              //value={values.unidadMedida}
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Precio Unitario: Bs.</span>
            </div>
            <input
              type="text"
              ref={txtPrecioUnitario}
              name="precioUnitario"
              disabled={operacion === 4 || operacion === 3}
              className="form-control text-right"
              //defaultValue={values.precioUnitario}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
            />
          </div>
          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Cantidad</span>
            </div>
            <input
              type="text"
              ref={txtCantidad}
              name="cantidad"
              disabled={operacion === 4 || operacion === 3}
              className="form-control text-right"
              autoComplete='off'
              //defaultValue={values.cantidad}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
            />
          </div>
          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Descuento: Bs.</span>
            </div>
            <input
              type="text"
              ref={txtDescuento}
              name="descuento"
              disabled={operacion === 4 || operacion === 3}
              className="form-control text-right"
              autoComplete='off'
              //defaultValue={values.descuento}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
            />
          </div>
          <div className='col-md-6'></div>
          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">% IVA</span>
            </div>
            <input
              type="text"
              ref={txtPorcentajeIva}
              name="porcentajeIva"
              //disabled={operacion === 4 || operacion === 3}
              className="form-control text-right"
              autoComplete='off'
              //defaultValue={values.porcentajeIva}
              readOnly={deshabilitado}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
            />
          </div>
          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Monto IVA: Bs.</span>
            </div>
            <input
              type="text"
              ref={txtMontoIva}
              name="montoIva"
              disabled={operacion === 4 || operacion === 3}
              className="form-control text-right"
              //value={values.montoIva}
              readOnly
            />
          </div>
          <div className="col-md-3">  </div>

          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Garantía</span>
            </div>
            <input
              type="text"
              ref={txtGarantia}
              name="garantia"
              disabled={operacion === 4 || operacion === 3}
              className="form-control text-left"
              autoComplete='off'
              //defaultValue={values.garantia}
              onKeyUp={handleGarantia}
            /*onBlur={handleInputMontoChange}*/
            />
          </div>
          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Total sin IVA: Bs.</span>
            </div>
            <input
              type="text"
              ref={txtTotalSinIva}
              name="totalSinIva"
              className="form-control text-right"
              //value={values.totalSinIva}
              readOnly
            />
          </div>
          <div className="input-group input-group-sm col-md-3 mb-1 px-0">
            <div className="input-group-prepend">
              <span className="input-group-text">Total</span>
            </div>
            <input
              type="text"
              name="garantia"
              disabled
              className="form-control text-left"
              autoComplete='off'
              onKeyUp={handleGarantia}
              value={total}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm rounded-pill btn-danger col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};